import React, { useState, useEffect } from 'react';
import { Building2, Award, Users, Newspaper, Mountain, Recycle } from 'lucide-react';
import '../AboutStyles/AboutSection.css';
import purpose from '../BitsImages/purposeimage.jpeg';

const AboutSection = () => {
  const [imageIndex, setImageIndex] = useState(0);

  const images = [purpose];

  useEffect(() => {
    const timer = setInterval(() => {
      setImageIndex((prev) => (prev + 1) % images.length);
    }, 2000);

    return () => clearInterval(timer);
  }, [images.length]); 

  return (
    <div className="max-w-7xl mx-auto px-4 py-12 animate-slide-up">
      <div className="grid lg:grid-cols-2 gap-8 items-center">
        <div>
          <h2 className="text-4xl mb-6">
            <span className="font-light">Bellary</span>
            <span className="font-medium"> Info Tech Solutions.</span>
          </h2>
          
          <p className="text-gray-700 mb-8" style={{color:'black'}}>
            Bellary Info Tech Solutions is not just another startup – it’s the future of digital innovation.
            We specialize in developing innovative applications to address billing challenges. Our flagship product,
            the BITS Engine, efficiently generates accurate billing amounts based on user-specific criteria. Additionally,
            we focus on creating seamless mobile apps and enhancing user experiences through robust web applications.
            We’re also pioneers in building smart billing systems and payment solutions that are designed to scale with your business needs.
          </p>
        </div>

        <div className="relative rounded-lg overflow-hidden shadow-xl h-[400px]">
          {images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Office ${idx + 1}`}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                idx === imageIndex ? 'opacity-100' : 'opacity-0'
              }`}
            />
          ))}
        </div>
      </div>

      
        
      </div>
    
  );
};

export default AboutSection;
